// The history shows an entry with this reason as the opening balance, so the server refuses it for an adjustment.
export const FREE_CREDITS_OPENING_BALANCE_REASON = 'Opening balance';

export const FREE_CREDITS_HINT =
  'Free credits cover billable overage only. They are deducted when overage is invoiced: ' +
  'in full blocks during the period and the rest at renewal, so the latest overage may not be subtracted yet.';
